import { formatPrice } from "./format";
import { settingsCache } from "./settingsCache";

export function buildOrderMessage({ contact, items, subtotal, coupon, discount }) {
  const lines = [
    `New order request from ${contact.name} (${contact.phone})`,
    "",
    ...items.map((i) => {
      const options = i.options?.length
        ? ` (${i.options.map((o) => `${o.name}: ${o.value}`).join(", ")})`
        : "";
      return `• ${i.name}${options} x${i.quantity} — ${formatPrice(i.price * i.quantity)}`;
    }),
    "",
    `Subtotal: ${formatPrice(subtotal)}`,
  ];
  if (discount > 0) {
    lines.push(`Discount (${coupon.code}): -${formatPrice(discount)}`);
    lines.push(`Total: ${formatPrice(subtotal - discount)}`);
  }
  if (contact.address) lines.push(`Delivery address: ${contact.address}`);
  if (contact.notes) lines.push(`Notes: ${contact.notes}`);
  return lines.join("\n");
}

export function buildWhatsAppLink({ contact, items, subtotal, coupon, discount }) {
  const text = encodeURIComponent(buildOrderMessage({ contact, items, subtotal, coupon, discount }));
  const number = settingsCache.whatsappNumber;
  return `https://wa.me/${number}?text=${text}`;
}
